module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_1",
      "title": "[Pg 1]"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "First_Day"
    }
  }, [_vm._v("First Day.")])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i05"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "",
      "id": "id-8083061090973934684",
      "src": "Images/img0002.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("A good action is its own")]), _vm._v(" "), _c('div', {
    staticClass: "verse1"
  }, [_vm._v("reward.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Dickens.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("The will to do well ... is the next")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("thing to having the power.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Mr. Pecksniff.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Forgiveness is a high quality,")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("an exalted virtue.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Martin Chuzzlewit.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("In love of home the love of")]), _vm._v(" "), _c('div', {
    staticClass: "verse3"
  }, [_vm._v("country has its rise.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Old Curiosity Shop.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Tears never yet wound up a clock or worked")]), _vm._v(" "), _c('div', {
    staticClass: "verse4"
  }, [_vm._v("a steam-engine.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Sam Weller.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0